"use client";
import React, { useEffect, useState } from "react";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import dynamic from "next/dynamic";
import Image from "next/image";
import { ArrowDownPlaneEnds, DropdownArrowDown } from "../../../public/Theme";
import { FILTERS_HEADING } from "./constants";
import { modifyDynamicFilters } from "./helpers";

const FilterDrawer = dynamic(() => import("./FilterDrawer"));
const TypographyMontserrat = dynamic(
    () => import("../../Atoms/TypographyMontserrat")
);
const QuickFiltersList = dynamic(
    () => import("../../Molecules/QuickFiltersList")
);

const ProductFilters = ({
    filters,
    showQuickFilters = false,
    dynamicFilters,
}) => {
    const [filtersExpanded, setFiltersExpanded] = useState([]);
    const [selectedFilters, setSelectedFilters] = useState([]);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const router = useRouter();
    const pathName = usePathname();
    const searchParams = useSearchParams();

    const test = modifyDynamicFilters(dynamicFilters);

    useEffect(() => {
        setSelectedFilters((prev) => {
            let updatedArray = prev;
            // update the selected filters state with the values in query params
            searchParams?.forEach((value, key) => {
                updatedArray?.push({ type: key, value: value });
                // this condition is to expand the filters section
                // in which the filters are selected
                if (!filtersExpanded?.includes(key))
                    setFiltersExpanded((prev) => [...prev, key]);
            });
            return updatedArray;
        });
    }, [searchParams]);

    // This useEffect is to add the selected filters to the URL
    useEffect(() => {
        let urlParams = new URLSearchParams();
        let urlParamsArray = urlParams?.toString()?.split("&");
        selectedFilters?.forEach((filter) => {
            let filterString = `${filter?.type}=${filter?.value}`;
            if (!urlParamsArray?.includes(filterString)) {
                urlParams?.append(filter?.type, filter?.value);
            } else urlParams?.delete(filter?.type, filter?.value);
        });
        let url = `${pathName}?${urlParams}`;
        if (urlParams?.toString()) router?.push(url);
    }, [selectedFilters]);

    return (
        <div className="w-full">
            <div
                className={
                    "py-0.5 sm:py-2 p-px sm:px-2 flex flex-col-reverse sm:flex-row gap-y-1 justify-between sm:items-center " +
                    !showQuickFilters
                        ? "justify-end"
                        : ""
                }
            >
                {showQuickFilters && <QuickFiltersList />}
                <div
                    onClick={() => setDrawerOpen(!drawerOpen)}
                    className="flex items-center cursor-pointer gap-x-2"
                >
                    <TypographyMontserrat
                        fontWeight={"normal"}
                        size={"base"}
                        text={FILTERS_HEADING}
                    />
                    <Image
                        width={20}
                        height={20}
                        src={ArrowDownPlaneEnds}
                        className="w-auto h-auto"
                        alt="Funnel Icon"
                    />
                </div>
            </div>

            <FilterDrawer
                filtersData={filters}
                drawerOpen={drawerOpen}
                setDrawerOpen={setDrawerOpen}
            />
        </div>
    );
};

export default ProductFilters;
